import { Paper, styled } from '@mui/material';
import Link from 'components/Link';
import MediaTypography from 'components/MediaTypography';

export const NewsItemLink = styled(Link)(() => ({
	color: 'transparent',
	textDecoration: 'none',
	maxWidth: '100%',
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	flex: 1,
}));

export const NewsItemWrap = styled(Paper)(({ theme }) => ({
	position: 'relative',
	padding: '8px',
	borderRadius: '20px',
	display: 'flex',
	alignItems: 'flex-start',
	flexDirection: 'column',
	overflow: 'hidden',
	transition: 'all .3s',
	'&:hover': {
		boxShadow: '0px 0px 30px 0px #827D8380',
		background: '#fff',
		'& h2': {
			color: theme.palette.primary.main,
		},
	},
}));

export const NewsItemImage = styled('img')(() => ({
	maxWidth: '100%',
	borderRadius: '10px',
	objectFit: 'cover',
	objectPosition: 'center',
	width: '100%',
	aspectRatio: '16 / 9',
}));

export const NewsItemDate = styled('span')(() => ({
	fontSize: '12px',
	lineHeight: '22px',
	fontWeight: 600,
	letterSpacing: 0.1,
	color: '#C1C1C1',
	marginTop: '16px',
}));

export const NewsItemTitle = styled(MediaTypography)(() => ({
	margin: '4px 0px 0px 0px',
	transition: 'all .3s',
}));

export const StyledNewsItemNewBadge = styled('div')(({ theme }) => ({
	position: 'absolute',
	top: '24px',
	right: '0px',
	background: theme.palette.error.contrastText,
	color: theme.palette.error.main,
	textTransform: 'uppercase',
	padding: '2px 8px',
	borderRadius: '8px 0px 0px 8px',
	boxShadow: '2px 2px 3px 0px rgba(0, 0, 0, 0.5)',
}));
